<template>
  <div class="connectDropdown">
    <div class="container">
      <div class="option" v-if="isExcluded" @click="unexclude">
        <span class="text">Cancel break</span>
      </div>
      <div class="option" v-else @click="exclude">
        <span class="text">Take a break</span>
      </div>
      <div class="option" @click="block">
        <span class="text">Block</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BlockExcludeDropdown",
  props: {
    isExcluded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async exclude() {
      this.$emit("exclude");
    },
    async unexclude() {
      this.$emit("unexclude");
    },
    async block() {
      this.$emit("block");
    },
  },
};
</script>
